module.exports = {
          srcSet: __webpack_public_path__ + "7ed2b94c86c8361ef097dbfc036a4db7-19.png"+" 19w",
          images:[ {path: __webpack_public_path__ + "7ed2b94c86c8361ef097dbfc036a4db7-19.png",width: 19,height: 305}],
          src: __webpack_public_path__ + "7ed2b94c86c8361ef097dbfc036a4db7-19.png",
          toString:function(){return __webpack_public_path__ + "7ed2b94c86c8361ef097dbfc036a4db7-19.png"},
          
          width: 19,
          height: 305
        }